import { FC } from 'react';
import Image, { ImageProps } from 'next/legacy/image';
import { cx } from '@emotion/css';

import { PhoenixImage } from '../assets/phoenix-image';

export interface EditorialCardImageProps {
  src: string;
  alt?: string;
  isPhoenix?: boolean;
  className?: string;
  sizes?: string;
  staticTags?: string[];
}

export const EditorialCardImage: FC<React.PropsWithChildren<EditorialCardImageProps>> = ({
  src,
  alt,
  isPhoenix = false,
  className,
  sizes,
  staticTags,
}) => {
  const props: ImageProps = { src, layout: 'fill', objectFit: 'cover' };

  return (
    <div className={cx('relative', className)}>
      {isPhoenix ? (
        <PhoenixImage {...props} sizes={sizes} staticTags={staticTags} />
      ) : (
        <Image {...props} loader={() => src} unoptimized={true} alt={alt} aria-hidden={!alt} />
      )}
    </div>
  );
};
